import { Comercio } from './comercio.model';
import { CardRelation } from './cardrelation.model';
import { TipoCupon } from './tipocupon.model';
import { BranchRelation } from './branchrelation.model';

export class Promo{

  constructor(public idPromocion: number, public idTipoPromocion: number, public nombre: string, public descripcion: string, public vigenciaInicio: string,
    public vigenciaFin: string, public terminos: string, public importancia: number, public urlImagen: string,
    public urlImagenDetalle: string, public targetInformativa: number, public urlTargetInformativa: string, public activo: number, public presencia: string, public proximamente: number,
    public tipoCupon: TipoCupon, public comercio: Comercio, public tarjetas: CardRelation[],
    public sucursales: BranchRelation[], public ciudades: string[]) {}

}
